import { STRING, DATE, TIME, DATETIME, NUMBER, INTEGER } from '@/plugins/sdk/fields'

export default {
  label: 'Is empty',
  operator: 'is null',
  fields: [ STRING, DATE, TIME, DATETIME, NUMBER, INTEGER ],
  isValidValue () {
    return true
  }
}
